import type {
  ApiResponse,
} from "@/scripts/Common/api";

import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  getToken,
} from "@/scripts/Common";

import type {
  Operator,
} from "@/components/operator/scripts/types";

const fetchOperator = async (): Promise<ApiResponse<Operator>> => await defaultFetch({
  apiName: 'operator',
  bearer: getToken()
})

const createOrUpdateOperator = async (operator: Operator, method: httpMethod.PUT | httpMethod.POST)
  : Promise<ApiResponse<Operator>> => await defaultFetch({
  apiName: 'operator',
  options: {
    method
  },
  body: JSON.stringify(operator),
  bearer: getToken()
})

export {
  fetchOperator,
  createOrUpdateOperator
}
